<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col md="9">
            <h3>Gerenciar Programas do Município</h3>
          </b-col>
          <b-col md="3">
            <p><b>Nome:</b> {{usuario.nome}}</p>
            <p><b>Perfil:</b> {{usuarioLogado.perfil}}</p>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col offset-md="9" md="3">
            <b-button @click="navigate('/admin/programa-municipio/cadastrar')" block variant="primary">
              <i class="fa fa-plus"></i>
              <span>Novo Programa do Município</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <b-form-group label="Nome, Texto descrição:">
              <b-form-input type="text" id="name" v-model="filtros.filter"
                placeholder="Nome ou descrição do programa do município"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="3">
            <b-form-group label="UF:">
              <b-form-select v-model="filtros.uf_id" :options="estados" class="mb-3">
                <option selected :value="null"> Selecione</option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col sm="4">
            <b-form-group label="Município:" :disabled="disabled_cidades">
              <b-form-select v-model="filtros.municipio_id" :options="cidades">
                <option selected :value="null"> Selecione</option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col sm="4">
            <b-form-group>
              <b-form-group label="Ativo:">
                <b-form-select v-model="filtros.ativo" class="mb-3">
                  <option selected :value="null"> Selecione</option>
                  <option selected :value="true"> Sim</option>
                  <option selected :value="false"> Não</option>
                </b-form-select>
              </b-form-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2">
            <b-button @click="limpafiltro" block variant="cinza">
              <i class="fa fa-eraser"></i>
              <span>Limpar filtros</span>
            </b-button>
          </b-col>
          <b-col md="2">
            <b-button @click="pesquisar" block variant="primary">
              <i class="fa fa-search"></i>
              <span>Pesquisar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
      <b-row>
        <b-col sm="12">
          <b-container fluid>
            <span>
              <b-form-select style="width: 100px; float: right" class="mb-3" v-model="totalPorPagina"
                :options="totalSelectOp"></b-form-select>
              <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7"
                class="table table-responsive-sm table-bordered table-striped table-sm">
                <thead class="text-center">
                  <tr>
                    <th scope="col">Programa de Ações</th>
                    <th scope="col">UF</th>
                    <th scope="col">Município</th>
                    <th scope="col">Ativo?</th>
                    <th scope="col">Ações</th>
                  </tr>
                </thead>
                <tbody v-if="programaDeMunicipios.data !== undefined" class="text-center">
                  <tr v-for="programa in programaDeMunicipios.data" :key="programa.id">
                    <td>{{programa.nome}}</td>
                    <td>{{programa.uf_id ? programa.estado.sigla : '-' }}</td>
                    <td>{{programa.municipio_id ? programa.cidade.cidade : '-' }}</td>
                    <td>{{programa.ativo ? 'Sim' : 'Não'}}</td>
                    <td style="width: 15%">
                      <a class="btn btn-sm btn-secondary action" title="Editar Programa"
                        @click="editarCaptcha(programa.id)">
                        <i class="fa fa-pencil-square-o"></i>
                      </a>
                      <a class="btn btn-sm btn-secondary action" title="Excluir Programa"
                        @click="excluirPrograma(programa.id)">
                        <i class="fa fa-times"></i>
                      </a>
                      <span v-if="programa.ativo">
                        <a class="btn btn-sm btn-secondary action" title="Inativar Programa"
                          @click="desativarPrograma(programa.id)">
                          <i class="fa fa-toggle-on"></i>
                        </a>
                      </span>
                      <span v-if="!programa.ativo">
                        <a class="btn btn-sm btn-secondary action" title="Ativar Programa"
                          @click="ativarPrograma(programa.id)">
                          <i class="fa fa-toggle-off"></i>
                        </a>
                      </span>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="action">
                    <td colspan="5">Nenhum registro de programas de municípios...</td>
                  </tr>
                </tbody>
              </table>
              <pagination v-show="programaDeMunicipios.data !== undefined" :totalPorPagina="totalPorPagina"
                :resource="resource" :filtros="filtros"></pagination>
            </span>
          </b-container>
        </b-col>
      </b-row>
    </b-card>
  </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import { eventType } from '@/components/shared/eventType'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

export default {
  components: {
    Pagination
  },
  created () {
    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'A') {
      this.$store.dispatch('getAdministradores')
      this.$store.dispatch('buscarEstados')
      this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
    } else {
      this.$router.push('/')
    }
  },
  data () {
    return {
      mainProps: { width: 250, height: 250 },
      disabled_cidades: true,
      videoSimular: '',
      respostaFinal: false,
      countadorErros: 0,
      tentativas: 1,
      respostaErrada: false,
      respostaCerta: false,
      modalSimular: false,
      totalPorPagina: 20,
      totalSelectOp: [
        { text: '20', value: 20 },
        { text: '30', value: 30 },
        { text: '50', value: 50 },
        { text: '100', value: 100 }
      ],
      resource: 'programaDeMunicipios',
      usuarioLogado: {
        municipio: '',
        estado: '',
        perfil: ''
      },
      filtros: {
        filter: '',
        uf_id: null,
        municipio_id: null,
        ativo: null
      }
    }
  },
  computed: {
    administradores () {
      return this.$store.state.usuario.administradores
    },
    programaDeMunicipios () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    },
    estados () {
      return this.$store.state.estado.listaEstados
    },
    cidades () {
      return this.$store.state.cidade.listaCidadesPorEstado
    }
  },
  watch: {
    'filtros.uf_id': function () {
      if (this.filtros.uf_id !== null) {
        this.$store.dispatch('buscarCidadesPorEstado', this.filtros.uf_id)
        this.disabled_cidades = false
      } else {
        this.disabled_cidades = true
        this.filtros.municipio_id = null
      }
    },
    'usuario.perfil': function () {
      this.usuarioLogado.perfil = this.usuario.perfil.nome
    }
  },
  methods: {
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    pesquisar () {
      this.$store.dispatch('getRegistrosSearch', {
        resource: this.resource,
        limit: this.totalPorPagina,
        filtros: this.filtros
      })
      this.setarFiltros(this.filtros)
    },
    limpafiltro () {
      this.filtros = {
        filter: '',
        uf_id: null,
        municipio_id: null,
        ativo: null
      }
      this.pesquisar()
    },
    editarCaptcha (id) {
      this.$router.push('/admin/programa-municipio/editar/' + id)
    },
    excluirPrograma (id) {
      this.$bvModal.msgBoxConfirm('Deseja realmente excluir esse programa do município?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.delete('api/programaDeMunicipios/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            }
          }).catch(erro => {
            if (!erro.body.success) {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-check' })
              miniToastr.error(erro.body.msg, 'Alerta!', 7000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            }
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    desativarPrograma (id) {
      this.$bvModal.msgBoxConfirm('Confirma a desativação do programa selecionado?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.get('api/programaDeMunicipio/desativar/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            }
          })
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-check' })
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
          this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
        }
      })
    },
    ativarPrograma (id) {
      this.$bvModal.msgBoxConfirm('Confirma a ativação do programa selecionado?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.get('api/programaDeMunicipio/ativar/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            }
          })
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-check' })
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
          this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
        }
      })
    },
    navigate (route) {
      this.$router.push(route)
    },
    validaForm () {
      let valid = true
      if (this.$v.form.descricao.$model === '') {
        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
        miniToastr.error('Campo texto é obrigatorio.', this.titulo_toast, 5000)
        this.textoValid = false
        valid = false
      } else {
        this.textoValid = true
      }

      if (this.files.length > 0) {
        this.form.files = []

        for (let i = 0; i < this.files.length; i++) {
          let reader = new FileReader()
          reader.readAsDataURL(this.files[i].file)
          reader.onload = () => {
            this.form.files.push(reader.result)
          }
        }
        this.fileValid = true
      } else {
        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
        miniToastr.error('Campo Anexo imagem é obrigatorio.', this.titulo_toast, 5000)
        this.fileValid = false
        valid = false
      }
      return valid
    }
  }
}
</script>

<style scoped>
.action {
  cursor: pointer;
}

td {
  max-width: 25ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/programaMunicipio/programaMunicipio.vue